(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
  
  document.addEventListener('DOMContentLoaded', () => {
  const desktopMenus = document.querySelectorAll(
    '.header__inline-menu header-menu'
  );

  desktopMenus.forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');

    if (!details || !summary) return;

    let closeTimer;

    menu.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;

      clearTimeout(closeTimer);

      // Close other open desktop dropdowns
      desktopMenus.forEach((otherMenu) => {
        if (otherMenu === menu) return;

        const otherDetails = otherMenu.querySelector(':scope > details');

        if (otherDetails) {
          otherDetails.removeAttribute('open');

          const otherSummary = otherDetails.querySelector(':scope > summary');
          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });

      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;

      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 150);
    });
  });
});
const nestedMenus = document.querySelectorAll(
  '.header__inline-menu .header__submenu details'
);

nestedMenus.forEach((details) => {
  const summary = details.querySelector(':scope > summary');

  if (!summary) return;

  let nestedCloseTimer;

  details.addEventListener('mouseenter', () => {
    if (window.innerWidth < 990) return;

    clearTimeout(nestedCloseTimer);

    // Close sibling nested submenus
    const parentList = details.parentElement?.parentElement;

    if (parentList) {
      parentList
        .querySelectorAll(':scope > li > details[open]')
        .forEach((otherDetails) => {
          if (otherDetails === details) return;

          otherDetails.removeAttribute('open');

          const otherSummary =
            otherDetails.querySelector(':scope > summary');

          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        });
    }

    details.setAttribute('open', '');
    summary.setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('mouseleave', () => {
    if (window.innerWidth < 990) return;

    nestedCloseTimer = setTimeout(() => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }, 150);
  });
});

  } catch(e) { console.error(e); }
})();
})();
